import { h } from '../dom';
import { api, type Session, type User } from '../../api/client';
import { avatar, confirmBox, empty, guard, photoImg, section, skeleton } from '../components';
import { openPhoto, shareDialog } from '../post';
import { shell } from '../shell';
import { navigate } from '../router';

const fmt = new Intl.DateTimeFormat('vi-VN', { dateStyle: 'medium', timeStyle: 'short' });

/** One photo session: date, people, thumbnails, share/hide actions. */
export function sessionCard(s: Session, reload?: () => void) {
  return h('section.lsession', {},
    h('div.lhead', {},
      h('b', {}, fmt.format(new Date(s.startedAt))),
      h('div.avs', {}, ...s.participants.map((p) => avatar(p.user, 24))),
      reload ? h('button.link', {
        onclick: async () => {
          if (!(await confirmBox('Ẩn bộ ảnh này khỏi thư viện của bạn?', 'Ẩn'))) return;
          await guard(api.hideSession(s.id)); reload();
        },
      }, 'Ẩn') : null),
    h('div.lgrid', {}, ...s.photos.map((p) =>
      h('button.lthumb', { class: p.kind.toLowerCase(), 'aria-label': p.kind === 'STRIP' ? 'Dải ảnh' : `Kiểu ${p.index + 1}`,
        onclick: () => openPhoto(p, p.kind === 'STRIP' ? 'Dải ảnh' : `Kiểu ${p.index + 1}`) },
      photoImg(p, 'pimg')))),
    h('div.row', {}, h('button.secondary.small', { onclick: () => shareDialog(s, () => navigate('#/feed')) }, '📤 Đăng lên bảng tin')));
}

export function sessionList() {
  return section(() => api.library(), (sessions, reload) => {
    if (!sessions.length)
      return empty('🗂', 'Vào phòng chụp cùng bạn bè, dải ảnh sẽ được lưu ở đây.', h('a.primary.btn', { href: '#/rooms' }, '🎞 Rủ bạn chụp'), 'Chưa có bộ ảnh nào');
    return h('div.stack', {}, ...sessions.map((s: Session) => sessionCard(s, reload)));
  }, () => skeleton('post', 2));
}

export function renderLibrary(root: HTMLElement, _me: User) {
  const content = shell(root, { title: 'Thư viện ảnh', back: '#/me' });
  content.append(sessionList());
}
